module.exports = __webpack_public_path__ + "img/Oakland City Station Concepts_Page_2.5eb1c1c5.jpg";